// INTENTIONALLY INSECURE DEMO.
// These are FAKE credentials with invalid signatures. They are not real keys,
// are not connected to any account, and exist only so Prewarn's scanner has
// something to find in the browser bundle. Never put a real secret here.
// In the clean twin the values are empty. The env check is written inline (not via
// lib/mode.ts) on purpose: the bundler only folds the condition, and drops the strings,
// when it sees the inlined value right here.

// A fake Supabase service_role JWT (role=service_role). Dummy signature.
export const SUPABASE_SERVICE_ROLE_KEY = process.env.NEXT_PUBLIC_TIDYROSTER_SECURE === "1"
  ? ""
  : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRpZHlyb3N0ZXJkZW1vIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwMDAwMDAwMCwiZXhwIjoyMDAwMDAwMDAwfQ.FAKE_demo_signature_not_a_real_key_do_not_use";

export const SUPABASE_URL = "https://tidyrosterdemo.supabase.co";

// A fake Stripe-style live secret (invalid). Pattern only, for the scanner.
export const STRIPE_SECRET = process.env.NEXT_PUBLIC_TIDYROSTER_SECURE === "1" ? "" : "sk_live_FAKE000demo000NOTAREALKEY000abcdef";
